import React, { useState } from 'react';

import { SingleSelectDropdown } from '../../../components/select-dropdown';
import styled from 'styled-components';

interface DepartmentSelectProps {
  onChange: (value: string) => void;
  value?: string;
  errorMessage?: string;
}

interface Option {
  label: string;
  value: string;
}

const createOption = (department: string | { _id: string; name: string }) => ({
  label: typeof department === 'string' ? department : department.name,
  value: typeof department === 'string' ? department : department._id,
});

const initialState: Option[] = [
  {
    value: 'Accounting',
    label: 'Accounting',
  },
  {
    value: 'Agency',
    label: 'Agency',
  },
  {
    value: 'Art',
    label: 'Art',
  },
  {
    value: 'Camera',
    label: 'Camera',
  },
  {
    value: 'Casting',
    label: 'Casting',
  },
  {
    value: 'Catering',
    label: 'Catering',
  },
  {
    value: 'Construction',
    label: 'Construction',
  },
  {
    value: 'Craft',
    label: 'Craft',
  },
  {
    value: 'Electric',
    label: 'Electric',
  },
  {
    value: 'Grip',
    label: 'Grip',
  },
  {
    value: 'Location',
    label: 'Location',
  },
  {
    value: 'Make Up and Hair',
    label: 'Make Up and Hair',
  },
  {
    value: 'Miscellaneous',
    label: 'Miscellaneous',
  },
  {
    value: 'Music',
    label: 'Music',
  },
  {
    value: 'Post Production',
    label: 'Post Production',
  },
  {
    value: 'Production',
    label: 'Production',
  },
  {
    value: 'Production Office',
    label: 'Production Office',
  },
  {
    value: 'Property',
    label: 'Property',
  },
  {
    value: 'Script',
    label: 'Script',
  },
  {
    value: 'SFX',
    label: 'SFX',
  },
  {
    value: 'Sound',
    label: 'Sound',
  },
  {
    value: 'Studio Operation',
    label: 'Studio Operation',
  },
  {
    value: 'Stunt',
    label: 'Stunt',
  },
  {
    value: 'Transportation',
    label: 'Transportation',
  },
  {
    value: 'VFX',
    label: 'VFX',
  },
  {
    value: 'Video',
    label: 'Video',
  },
  {
    value: 'Wardrobe',
    label: 'Wardrobe',
  },
  {
    value: 'Wrangling',
    label: 'Wrangling',
  },
];

export const DepartmentSelect: React.FC<DepartmentSelectProps> = ({
  onChange,
  value,
}) => {
  const [options, setOptions] = useState<Option[]>(initialState);

  const handleCreate = (inputValue: string) => {
    if (inputValue === '') return;

    const newOption = createOption(inputValue);
    setOptions([...options, newOption]);

    new Promise<void>((resolve) => resolve()).then(() => {
      handleChange(inputValue);
    });
  };

  const handleChange = (value: string) => {
    onChange(value);
  };


  return (
    <Container>
      <SingleSelectDropdown
        title={'Name'}
        placeholder="Choose from the list or use your own"
        options={options}
        onValueChange={handleChange}
        onCreate={handleCreate}
        value={value}
      />
    </Container>
  );
};

const Container = styled.div`
  .trigger {
    border: 1px solid var(--color-stroke-default);

    &:hover {
      border-color: var(--color-stroke-hover);
    }
  }
`;
